import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CalculatorIcon, EuroIcon } from 'lucide-react';
export function CommissionCalculator() {
  const [rent, setRent] = useState<string>('500');
  const [showResult, setShowResult] = useState(false);
  const handleCalculate = () => {
    setShowResult(true);
  };
  const rentNum = parseFloat(rent) || 0;
  const commissionBase = rentNum * 0.5;
  const vat = commissionBase * 0.21;
  const totalCommission = commissionBase + vat;
  return <div className="space-y-6" data-id="element-617">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl p-8 shadow-xl border-2 border-[#357BEB]" data-id="element-618">
        <div className="flex items-center space-x-3 mb-8" data-id="element-619">
          <CalculatorIcon className="w-8 h-8 text-[#357BEB]" data-id="element-620" />
          <h3 className="text-2xl font-bold text-[#132C53]" data-id="element-621">
            Calculează comisionul tău rapid
          </h3>
        </div>
        <p className="text-gray-600 mb-6" data-id="element-622">
          Introdu chiria lunară și calculează automat comisionul agenției cu TVA
          inclus.
        </p>
        <div className="space-y-6" data-id="element-623">
          <div data-id="element-624">
            <label className="block text-sm font-semibold mb-4 text-[#132C53]" data-id="element-625">
              Chirie lunară (€)
            </label>
            <div className="flex items-center justify-center" data-id="element-626">
              <input type="number" value={rent} onChange={e => setRent(e.target.value)} className="text-5xl font-bold text-center text-[#132C53] bg-transparent border-none focus:outline-none w-full" placeholder="500" min="0" step="50" data-id="element-627" />
              <EuroIcon className="w-10 h-10 text-[#357BEB] ml-2" data-id="element-628" />
            </div>
          </div>
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={handleCalculate} className="w-full bg-gradient-to-r from-[#357BEB] to-[#2868d8] text-white px-6 py-4 rounded-2xl font-bold hover:shadow-xl transition-shadow" data-id="element-629">
            Calculează comisionul
          </motion.button>
        </div>
      </motion.div>
      <AnimatePresence data-id="element-630">
        {showResult && <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="bg-white rounded-2xl overflow-hidden shadow-xl border-2 border-[#357BEB]" data-id="element-631">
            <div className="bg-gradient-to-r from-[#357BEB] to-[#2868d8] text-white p-6" data-id="element-632">
              <h4 className="text-xl font-bold mb-2" data-id="element-633">Rezultatul calculului</h4>
              <p className="text-gray-100" data-id="element-634">
                Chirie lunară: {rentNum.toLocaleString('ro-RO')}€
              </p>
            </div>
            <div className="p-6 space-y-4" data-id="element-635">
              <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.1
          }} className="flex justify-between items-center p-4 bg-blue-50 rounded-xl" data-id="element-636">
                <span className="text-[#132C53] font-semibold" data-id="element-637">
                  Comision (50%)
                </span>
                <span className="text-2xl font-bold text-[#357BEB]" data-id="element-638">
                  {commissionBase.toLocaleString('ro-RO', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
                  €
                </span>
              </motion.div>
              <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="flex justify-between items-center p-4 bg-blue-50 rounded-xl" data-id="element-639">
                <span className="text-[#132C53] font-semibold" data-id="element-640">TVA (21%)</span>
                <span className="text-2xl font-bold text-[#357BEB]" data-id="element-641">
                  {vat.toLocaleString('ro-RO', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
                  €
                </span>
              </motion.div>
              <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.3
          }} className="flex justify-between items-center p-6 bg-gradient-to-r from-[#21A366] to-[#1a8555] rounded-xl text-white" data-id="element-642">
                <span className="text-lg font-bold" data-id="element-643">Total comision</span>
                <span className="text-3xl font-bold" data-id="element-644">
                  {totalCommission.toLocaleString('ro-RO', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
                  €
                </span>
              </motion.div>
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-xl" data-id="element-645">
                <p className="text-sm text-[#132C53] font-medium" data-id="element-646">
                  💡 Comisionul este perceput după semnarea contractului.
                </p>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}